export class Translations {
    id: number;
    id_app: string;
    label: string;
}
export class Languages {
 lang : string;
 translations: Translations[];
   // Languages :Language[];
}